/**
 * O DIA DA OPERAÇÃO, num lugar só — mesa e celular.
 *
 * "Hoje" é o dia em São Paulo, o mesmo `FUSO_DA_OPERACAO` do servidor
 * (`backend/src/gestor/recorte.ts`, `dataNoFuso`), e não o dia em UTC. Achado
 * dos robôs no QAS (20/10/2026): onze telas escreviam "hoje" com
 * `new Date().toISOString().slice(0, 10)` — depois das 21:00 em São Paulo
 * isso já é amanhã, e o formulário de apontar da mesa abria o turno no dia
 * seguinte. Morava em `src/mobile/campo/pacote.ts`; veio para cá para a mesa
 * usar a mesma conta (o pacote o reexporta).
 *
 * Toda conta de dia da tela passa por aqui: o dia de um instante
 * (`diaDaOperacao`) e o calendário a partir de um dia (`somarDias`). O
 * verificador `src/lib/hoje-no-fuso.test.ts` reprova `toISOString()` cortado
 * em dia fora deste arquivo.
 */
export const FUSO_DA_OPERACAO = 'America/Sao_Paulo';

/** O dia `aaaa-mm-dd` no fuso da operação, como o servidor o escreve. */
export function diaDaOperacao(agora: Date = new Date()): string {
  /* `sv-SE` escreve aaaa-mm-dd — o formato ISO, sem montar à mão. É a mesma
     conta de `dataNoFuso` no servidor, e tem de ser: um pacote que o servidor
     diz valer hoje e a tela diz ter vencido deixaria a máquina parada no
     pátio sem motivo. */
  return agora.toLocaleDateString('sv-SE', { timeZone: FUSO_DA_OPERACAO });
}

/**
 * O dia `n` dias depois (ou antes, com `n` negativo) de um dia `aaaa-mm-dd`.
 * Conta de CALENDÁRIO: o meio-dia em UTC não vira de dia em fuso nenhum, então
 * o corte em UTC aqui é seguro — e é o único lugar da tela onde ele é.
 */
export function somarDias(dia: string, n: number): string {
  const d = new Date(`${dia}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** Os últimos `dias` dias terminando hoje, no fuso da operação. */
export function janelaAteHoje(dias: number, agora: Date = new Date()): { readonly de: string; readonly ate: string } {
  const ate = diaDaOperacao(agora);
  return { de: somarDias(ate, -dias), ate };
}
